import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SidenavService } from '@services/sidenav.service';

@Component({
	selector: 'app-sidebarwidget',
	templateUrl: './sidebarwidget.component.html',
	styleUrls: ['./sidebarwidget.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class SidebarwidgetComponent {
	@Input() public heading: string;
	@Input() public icon: string;
	public collapsed: boolean = false;

	constructor(private sidenavService: SidenavService) {}

	widgetHeaderClick() {
		this.collapsed = !this.collapsed;
		this.sidenavService.toggleRightPanelExpansion();
	}
}
